import { useRouter } from 'next/router'
import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'
import { H4, Label, ParagraphRegular } from '@/components/text'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${colors.background};
  padding-bottom: 80px;

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    padding-bottom: 280px;
  }
`

export const Section = styled.section`
  width: 100%;
  border-top: 1px solid ${colors.grey88};

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    width: 100%;
  }
`

export const Section1 = styled.div`
  max-width: calc(${breakpoints.desktop} + 40px);
  margin: 0 auto;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  color: ${colors.grey24};
  gap: 32px;
`

export const Section2 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const Section3 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const H1 = styled(H4)`
  margin: 0 0 4px;
  color: ${colors.regular};
`
export const Heading1 = ({ children }: { children: React.ReactNode }) => (
  <H1 as="h2">{children}</H1>
)

const H2 = styled(Label)`
  margin: 0;
  color: ${colors.regular};
`
export const Heading2 = ({ children }: { children: React.ReactNode }) => (
  <H2 as="h3" fontSize="18px" type="large">
    {children}
  </H2>
)

const H3 = styled(Label)`
  margin: 0;
  color: ${colors.regular};
`
export const Heading3 = ({ children }: { children: React.ReactNode }) => (
  <H3 as="h4" fontSize="16px" type="large">
    {children}
  </H3>
)

export const Paragraph = styled(ParagraphRegular)``

export const Anchor = styled.a`
  font-weight: 500;
  color: ${colors.link};
  text-decoration: none;
  line-height: 18px;
`

export const LinkText = ({
  href,
  children
}: {
  href: string
  children: React.ReactNode
}) => {
  const router = useRouter()
  const isEnglish = router.locale === 'en'
  const external = href.startsWith('http')
  const link = isEnglish || external ? href : `/${router.locale}${href}`

  return (
    <Anchor href={link} target="_blank" rel="noopener noreferrer">
      {children}
    </Anchor>
  )
}

export const LinkList = styled.ul`
  padding: 0;
  margin: 0 0 0 20px;

  li:not(:last-child) {
    margin-bottom: 8px;
  }
`

export const LinkItem = ({
  href,
  children
}: {
  href: string
  children: React.ReactNode
}) => (
  <li>
    <Paragraph>
      <LinkText href={href}>{children}</LinkText>
    </Paragraph>
  </li>
)

export const LinkGrid = styled.div<{ linksOnly?: boolean }>`
  display: grid;
  grid-template-columns: repeat(auto-fill, 260px);
  gap: ${props => (props.linksOnly ? '16px 20px' : '32px 20px')};
  justify-content: space-between;
`

export const LinkStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  h4 {
    margin-bottom: 4px;
  }
`
